var helpers = require('./helpers');
var experimentation = require('./experimentation');

module.exports = {
    init: async function () {
        const { StatsigClient, runStatsigAutoCapture } = window.Statsig;

        const $statsig = $('#statsig-data');
        const ipAddress = $statsig.data('ip');
        const environment = $statsig.data('environment');
        const apiKey = $statsig.data('key');

        const LOGLEVEL = {
            'Warn': 2,
            'Debug': 4
        };

        const defaultUser = {
            ip: ipAddress,
            customIDs: {
                stableID: crypto.randomUUID()

            },
            custom: { isInternal: Boolean(helpers.getCookie('INTERNAL_OR_OFFLINE')) }
        };

        const userCookieValue = helpers.getCookie('statsig_user');
        const user = userCookieValue ? JSON.parse(userCookieValue) : {};
        const statsigUser = { ...defaultUser, ...user };
        helpers.setStatsigUserCookie(statsigUser);

        const client = new StatsigClient(
            apiKey,
            statsigUser,
            {
                environment: {
                    tier: environment === 'production' ? 'production' : 'staging', // In order to match with modern where it's only staging and production
                },
                logLevel: environment === 'production' ? LOGLEVEL['Warn'] : LOGLEVEL['Debug'],
            }
        );

        helpers.addGTMTracking(client);

        runStatsigAutoCapture(client);

        await client.initializeAsync();
    }
};
